import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, JwtService, CommonService } from '@app/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';

function passwordConfirming(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const pwd = c.parent.get('pwd');
  const cpwd = c.parent.get('repwd')
  if (!pwd || !cpwd) return;
  if (pwd.value !== cpwd.value) {
    return { invalid: true };
  }
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  is_disable: boolean;
  is_RegisterSuccess: boolean = false;
  is_verifyEnable: boolean;
  vcodeValue: string = '';
  is_RegisterEnable: boolean;
  msgColor: string;
  asterik: string;
  message = "";
  loginMsg = "";

  get cpwd() {
    return this.registerForm.get('repwd');
  }
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private jwtService: JwtService,
    private commonService: CommonService,
    private modalService: NgbModal) {
    this.createForm();
    this.is_verifyEnable = false;
    this.is_disable = false;
    this.is_RegisterEnable = false;

  }
  ngOnInit() {
    this.jwtService.destroyToken();
    this.userService.getTokenFromAuthServer().subscribe(
      data => {
        console.log('Token Saved');
      },
      err => {
        console.log('Unable to connect to API URL');
      }
    )
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.jwtService.destroyToken();
  }
  cancel() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }
  registerUser() {
    this.verifyCode();
  }
  sendCode() {
    var sendcodedata = this.registerForm.value;
    const data = { "EmailAddress": sendcodedata.email };
    this.commonService.sendCode(data).subscribe(
      res => {
        if (res.code == '200') {
          this.is_disable = true;
          this.is_verifyEnable = true;
          this.is_RegisterEnable = true;
          this.message = "Verification Code Sent";
          this.msgColor = 'green';
          this.asterik = '*';
        }
      },
      err => {
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
      }
    );
    return false;
  }
  getStatusColor() {
    return this.msgColor;
  }

  EditEmail() {
    this.is_disable = false;
    this.is_RegisterEnable = false;
    this.is_verifyEnable = false;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  verifyCode() {
    var verifycodedata = this.registerForm.value;
    this.vcodeValue = null;
    this.is_verifyEnable = false;
    const data = {
      "EmailAddress": verifycodedata.email,
      "VerificationCode": verifycodedata.vcode
    };

    this.commonService.verifyCode(data).subscribe(
      res => {
        if (res.code == '200') {
          this.msgColor = 'green';
          var fdata = this.registerForm.value;
          var identityVO = JSON.parse(this.jwtService.getIdentity());
          const data = {
            "UserName": fdata.un, "Password": fdata.pwd,
            "Email": fdata.email,
            "participantId": identityVO.participantId,
            "roleId": identityVO.roleId,
            "roleType": identityVO.role
          };
          this.register(data);
          return true;
        }
        else {
          this.is_verifyEnable = true;
          return false;
        }
      },
      err => {
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
        this.is_verifyEnable = true;
        this.EditEmail();
        return false;
      }
    );
  }
  register(data: any) {
    this.userService.registerUser(data).subscribe(
      res => {
        if (res.code == '200') {
          this.is_RegisterSuccess = true;
          this.jwtService.destroyParticipantId();
          this.message = res.message;
          this.msgColor = 'green';
          this.asterik = '*';
          this.loginMsg = '<span>Please click <a  href="' + environment.ui_url + '/#/login">here</a> to login.</span>';
          this.is_RegisterEnable = false;
        }
      },
      err => {
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
        this.EditEmail();
      }
    );
  }
  onPasswordChange() {
    this.registerForm.patchValue({
      repwd: null
    });
  }
  private createForm() {
    this.registerForm = this.formBuilder.group({
      un: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(30),
        Validators.minLength(6),
        Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9!@#$&()\\-`.+,/\"]*$')
      ])),
      pwd: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(64),
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[A-Za-z0-9]+$')
      ])),
      repwd: ['', [Validators.required, passwordConfirming]],
      email: new FormControl('', [Validators.required, Validators.pattern('^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$'), Validators.maxLength(80)]),
      vcode: ['', Validators.required]
    });
  }
}


